<template>
  <div class="wrap">
    <div class="main_con fadeInUp animated">
      <div class="breadcrumb_con">
        <el-breadcrumb separator="/">
          <i class="el-icon-location-outline left icon-location"></i>
          <span class="left">{{ $t("common.CurrentLocation") }}：</span>
          <el-breadcrumb-item
            ><router-link to="/Home">{{
              $t("common.Glang")
            }}</router-link></el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ $t("top.Contact") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-divider></el-divider>
      <img
        class="header_img"
        v-if="head_img"
        :src="img_head_url + head_img.src"
      />
      <div class="body_con">
        <div class="service_con">
          <div class="con_title">{{ $t("common.CompanyName") }}</div>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-card class="service_card">
                <div class="service_item flex-display">
                  <div class="service_pic flex-display">
                    <i class="el-icon-headset"></i>
                  </div>
                  <div class="service_box">
                    <div class="service_title">{{ $t("footer.Phone") }}：</div>
                    <div class="service_content">15067699399 / 15857636096</div>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="service_card">
                <div class="service_item flex-display">
                  <div class="service_pic flex-display">
                    <i class="el-icon-chat-line-square"></i>
                  </div>
                  <div class="service_box">
                    <div class="service_title">{{ $t("footer.EMail") }}：</div>
                    <div class="service_content">service@glangpump.com</div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-card class="service_card">
                <div class="service_item flex-display">
                  <div class="service_pic flex-display">
                    <i class="el-icon-location-outline"></i>
                  </div>
                  <div class="service_box">
                    <div class="service_title">
                      {{ $t("footer.Address") }}：
                    </div>
                    <div class="service_content">
                      {{ $t("common.CompanyAddress") }}
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="service_card">
                <div class="service_item flex-display">
                  <div class="service_pic flex-display">
                    <i class="el-icon-monitor"></i>
                  </div>
                  <div class="service_box">
                    <div class="service_title">{{ $t("footer.Web") }}：</div>
                    <div class="service_content">www.glangtec.com</div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div class="message_con">
          <el-row :gutter="40">
            <el-col :span="12">
              <!--地图开始-->
              <baidu-map
                class="bm-view"
                ak="y6vPHnKQXIiCRY89vd1Ltpaq3hg4Rljd"
                :center="center"
                :zoom="zoom"
                @ready="handler"
              >
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
              </baidu-map>
              <!--地图结束-->
            </el-col>
            <el-col :span="12">
              <div class="con_title_small">
                {{ $t("contact.LeaveAMessage") }}
              </div>
              <el-form
                ref="addFormRef"
                :model="addForm"
                :rules="lang === 'cn' ? addFormRules : addFormRules1"
                label-width="80px"
                label-position="top"
              >
                <el-form-item :label="$t('contact.Name')" prop="name">
                  <el-input
                    v-model="addForm.name"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('contact.Phone')" prop="phone">
                  <el-input
                    v-model="addForm.phone"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('contact.EMail')" prop="email">
                  <el-input
                    v-model="addForm.email"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('contact.LeaveAMessage')" prop="text">
                  <el-input type="textarea" v-model="addForm.text"></el-input>
                </el-form-item>
                <el-button @click="onSubmit">{{
                  $t("contact.Send")
                }}</el-button>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmNavigation from 'vue-baidu-map/components/controls/Navigation.vue'
export default {
  components: {
    BaiduMap,
    BmNavigation
  },
  data () {
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入邮箱'))
      }
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])/
      // const regEmail = /^([\w-])+@([\w-])+(\.[A-z]+)$/
      if (regEmail.test(value)) {
        return callback()
      }
      callback(new Error('请输入合法的邮箱'))
    }
    var checkEmail1 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please enter email'))
      }
      const regEmail1 = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])/
      // const regEmail = /^([\w-])+@([\w-])+(\.[A-z]+)$/
      if (regEmail1.test(value)) {
        return callback()
      }
      callback(new Error('Please enter email'))
    }
    return {
      loading: false,
      addForm: {
        name: '',
        email: '',
        phone: '',
        text: ''
      },
      addFormRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        text: [{ required: true, message: '请输入留言', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ]
      },
      addFormRules1: {
        name: [
          {
            required: true,
            message: 'Please enter your name',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: 'Please enter your mobile phone number',
            trigger: 'blur'
          }
        ],
        text: [
          {
            required: true,
            message: 'Please fill in the message content',
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: 'Please enter email', trigger: 'blur' },
          { validator: checkEmail1, trigger: 'blur' }
        ]
      },
      center: { lng: 0, lat: 0 },
      zoom: 3,
      lang: localStorage.lang || 'cn',
      img_head_url: '',
      head_img: ''
    }
  },
  created () {
    var that = this
    that.getContactData()
  },
  mounted () {},
  methods: {
    handler ({ BMap, map }) {
      var that = this
      that.center.lng = 121.594158
      that.center.lat = 28.427515
      that.zoom = 18
    },
    onSubmit () {
      var that = this
      that.$refs.addFormRef.validate((valid) => {
        if (!valid) return
        var url = '/api/submit_message'
        that.$lcommon.ajaxRequest('post', url, that.addForm, function (res) {
          console.log(res)
          if (res.meta.status === 200) {
            that.$message.success('成功留言')
          } else {
            that.$message.error(res.meta.msg)
          }
        })
      })
    },
    getContactData () {
      var that = this
      var json = {
        lang: that.lang
      }
      var url = '/api/get_contact_us'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log(res)
        if (res.meta.status === 200) {
          that.head_img = res.data.head_img
          that.img_head_url = res.img_head_url
          if (that.$route.query.from === 'productdetail') {
            setTimeout(() => {
              that.$scrollTo('.message_con')
            }, 1)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.service_con {
  width: 1200px;
  margin: 0 auto 20px;
  position: relative;
  text-align: left;
}
.service_card {
  margin-bottom: 30px;
}
.service_card:hover {
  animation-name: hvr-bob-float, hvr-bob;
  animation-duration: 0.3s, 1s;
  animation-delay: 0s, 0.3s;
  animation-timing-function: ease-out, ease-in-out;
  animation-iteration-count: 1, infinite;
  animation-fill-mode: none, forwards;
  animation-direction: normal, alternate;
  box-shadow: 0 35px 35px rgba(50, 50, 93, 0.1);
}
@keyframes hvr-bob {
  0% {
    transform: translateY(-8px);
  }
  50% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(-8px);
  }
}
@keyframes hvr-bob-float {
  100% {
    transform: translateY(-8px);
  }
}
.service_item {
  position: relative;
  align-items: center;
}
.service_item .service_pic {
  position: relative;
  width: 64px;
  height: 64px;
  justify-content: center;
  align-items: center;
}
.service_item .service_pic i {
  font-size: 32px;
  color: #3c427c;
}
.service_item .service_box {
  padding-left: 32px;
  display: block;
  word-break: normal;
}
.service_item .service_box .service_title {
  font-size: 20px;
  line-height: 28px;
  border-bottom: 4px solid #f1f1f1;
  display: inline-block;
  padding: 0 0 8px;
  font-weight: bold;
  margin-bottom: 10px;
}
.service_item .service_box .service_content {
  overflow-wrap: initial;
  font-size: 16px;
  line-height: 32px;
}
.message_con {
  width: 1200px;
  margin: 0 auto 20px;
  position: relative;
  text-align: left;
  padding-top: 100px;
}
// 地图样式
#allmap {
  width: 100%;
  height: 600px;
  overflow: hidden;
  font-family: "微软雅黑";
}
#allmap b {
  color: #cc5522;
  font-size: 14px;
}
#allmap img {
  max-width: none;
}
.follow-us-right img {
  cursor: pointer;
  width: 2.3125rem;
  margin-right: 0.5rem;
}
.bm-view {
  width: 100%;
  height: 600px;
  overflow: hidden;
  font-family: "微软雅黑";
}
</style>
